/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Y_BottomInputs */



/**
* | output |
* | --- |
* | "Bottom" |
*
* @param {Input_Position_Y_BottomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_y_bottom = /** @type {((inputs?: Input_Position_Y_BottomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Y_BottomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bas")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metter il fondo a")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нижний")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("底部")
	if (locale === "ja") return /** @type {LocalizedString} */ ("底")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fundo")
	return /** @type {LocalizedString} */ ("Bottom")
});